import { Controller, useForm } from 'react-hook-form';
import { $cardUsersStore } from '@lib/store';
import { ValidateUtils } from '@shared/utils';
import type { UsersResponse } from '@shared/api/rest/users';
import { Button, Modal, Select } from '@shared/widgets';

interface IForm {
  user: string;
}
const DEFAULT_VALUES: IForm = { user: '' };

interface IAddUsersModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  cardId: string;
  usersList: UsersResponse[];
}

export const AddUsersModal = (props: IAddUsersModalProps) => {
  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });

  const closeHandler = () => {
    props.onClose();
    reset(DEFAULT_VALUES);
  };
  const submitHandler = async (data: IForm) => {
    await $cardUsersStore.events.addUsersInCard({ userIds: data.user, cardIds: [parseInt(props.cardId)] });
    closeHandler();
  };

  return (
    <Modal title={props.title} isOpen={props.show} onClose={closeHandler}>
      <form className='flex flex-col gap-6' onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='user'
          control={control}
          rules={{ required: ValidateUtils.requiredErrorMessage }}
          render={({ field }) => (
            <Select
              items={props.usersList.filter((user) => !user.locked).map((user) => ({ value: user.id, label: `${user.firstName} ${user.lastName}` }))}
              nullValue={{ isEnable: false, text: 'Select user' }}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <Button fullWidth color='primary' type='submit' disabled={formState.isSubmitting || !formState.isValid}>
          Add
        </Button>
      </form>
    </Modal>
  );
};
